import AuthLayoutContainerDefault from './AuthLayoutContainer';

export default AuthLayoutContainerDefault;



// WEBPACK FOOTER //
// ./src/client/Components/AuthLayoutContainer/index.js